import { Effect } from 'effect';

import { PRODUCT_RECOMMENDED_PRODUCTS_VALUE_ALL } from '@vs-shop/engine/config/product';

import { getAssociatedProducts } from '../../bind/product';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

// Define a Data.tagged type for type-safe atom keys with Equal implementation
type FetchAssociatedProductsKey = {
  readonly _tag: 'FetchAssociatedProductsKey';
  readonly productCode: string;
  readonly taxonCode: string | null;
  readonly page: number;
  readonly itemsPerPage: number;
};

const FetchAssociatedProductsKey = tagged<FetchAssociatedProductsKey>('FetchAssociatedProductsKey');

const fetchAssociatedProductsAtomFamily = Atom.family((key: FetchAssociatedProductsKey) => {
  return RuntimeClientAtom.atom(
    Effect.gen(function* () {
      const { productCode, taxonCode, page, itemsPerPage } = key;

      const taxonCodeValidated =
        taxonCode === PRODUCT_RECOMMENDED_PRODUCTS_VALUE_ALL ? null : taxonCode;

      return yield* getAssociatedProducts({
        productCode,
        taxonCode: taxonCodeValidated,
        page,
        itemsPerPage,
      });
    })
  ).pipe(Atom.keepAlive);
});

export const fetchAssociatedProductsPageAtom = (
  productCode: string,
  taxonCode: string | null,
  page: number,
  itemsPerPage: number
) => {
  const key = FetchAssociatedProductsKey({ productCode, taxonCode, page, itemsPerPage });

  return fetchAssociatedProductsAtomFamily(key);
};
